import React from 'react';
import { AppRoutes } from './routes';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './components/contexts/UserContext';

const App: React.FC = () => {
  
  return (
    <BrowserRouter>
      <UserProvider >
          <AppRoutes />
      </UserProvider>
    </BrowserRouter>
  );
};

export default App;